import { render } from "./AuditLogDialog.vue?vue&type=template&id=4b9b01c3"
import script from "./AuditLogDialog.vue?vue&type=script&lang=js"
export * from "./AuditLogDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__